<template>
	<el-container class="friend-page">
		<el-aside width="260px" class="aside">
			<div class="header">
				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" title="添加好友"
					@click="onShowAddFriend()"></el-button>
				<el-button plain class="request-btn" icon="el-icon-message" title="好友申请"
					@click="onShowFriendRequests()" v-if="hasPendingRequests">
					<span class="request-count">{{ pendingRequestCount }}</span>
				</el-button>
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"></add-friend>
			</div>
			<el-scrollbar class="friend-items">
				<div v-for="(friends, i) in friendValues" :key="i">
					<div class="letter">{{ friendKeys[i] }}</div>
					<div v-for="(friend) in friends" :key="friend.id">
						<friend-item :friend="friend" :active="friend.id === activeFriend.id"
							@chat="onSendMessage(friend)" @delete="onDelFriend(friend)"
							@click.native="onActiveItem(friend)">
						</friend-item>
					</div>
					<div v-if="i < friendValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</el-aside>
		<el-container class="container">
			<div class="header" v-show="userInfo.id">
				{{ userInfo.nickName }}
			</div>
			<div v-show="userInfo.id">
				<div class="friend-info">
					<head-image :size="160" :name="userInfo.nickName" :url="userInfo.headImage" radius="12px"
						@click.native="showFullImage()"></head-image>
					<div>
						<div class="info-item">
							<el-descriptions title="好友信息" class="description" :column="1">
								<el-descriptions-item label="用户名">{{ userInfo.userName }}
								</el-descriptions-item>
								<el-descriptions-item label="昵称">{{ userInfo.nickName }}
								</el-descriptions-item>
								<el-descriptions-item label="性别">{{ userInfo.sex == 0 ? "男" : "女"
								}}</el-descriptions-item>
								<el-descriptions-item label="签名">{{ userInfo.signature }}</el-descriptions-item>
							</el-descriptions>
						</div>
						<div class="btn-group">
							<el-button v-show="isFriend" icon="el-icon-position" type="primary"
								@click="onSendMessage(userInfo)">发消息</el-button>
							<el-button v-show="!isFriend" icon="el-icon-plus" type="primary"
								@click="onAddFriend(userInfo)">加为好友</el-button>
							<el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(userInfo)">删除好友</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-container>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import HeadImage from "../components/common/HeadImage.vue";
import { pinyin } from 'pinyin-pro';
import { mergeFriendRequestsBySender } from "../utils/friendRequest";

export default {
	name: "friend",
	components: {
		FriendItem,
		AddFriend,
		HeadImage

	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			userInfo: {},
			activeFriend: {},
			pendingRequests: []
		}
	},
	methods: {
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		openAddFriendFromRoute() {
			if (this.$route.query.addFriend === '1') {
				this.showAddFriend = true;
				this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {});
			}
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onShowFriendRequests() {
			this.$router.push("/home/friend-request");
		},
		loadPendingRequests() {
			this.$http({
				url: "/friend-request/received",
				method: "GET"
			}).then((data) => {
				this.pendingRequests = mergeFriendRequestsBySender(data).filter(req => req.status === 0);
			}).catch((error) => {
				console.error('加载好友申请失败:', error);
			})
		},
		onActiveItem(friend) {
			this.activeFriend = friend;
			this.loadUserInfo(friend.id);
		},
		onDelFriend(friend) {
			this.$confirm(`删除联系人“${friend.nickName}”后，是否同时清空聊天记录？`, '删除联系人', {
				confirmButtonText: '删除并清空',
				cancelButtonText: '仅删除联系人',
				distinguishCancelAndClose: true,
				type: 'warning'
			}).then(() => {
				this.deleteFriend(friend, true);
			}).catch((action) => {
				if (action === 'cancel') {
					this.deleteFriend(friend, false);
				}
			})
		},
		deleteFriend(friend, clearChatHistory) {
			this.$http({
				url: `/friend/delete/${friend.id}`,
				method: 'delete'
			}).then(() => {
				this.$message.success("删除联系人成功");
				this.friendStore.removeFriend(friend.id);
				if (clearChatHistory) {
					this.chatStore.removePrivateChat(friend.id);
				}
			}).catch((error) => {
				this.$message.error(error.message || '删除联系人失败');
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then(() => {
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImage,
					online: user.online
				}
				this.friendStore.addFriend(friend);
			})
		},
		onSendMessage(user) {
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: user.nickName,
				headImage: user.headImageThumb,
			};
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(0);
			this.$router.push("/home/chat");
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$eventBus.$emit("openFullImage", this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				this.chatStore.updateChatFromFriend(friend);
				this.friendStore.updateFriend(friend);
			}
		},
		loadUserInfo(id) {
			// 获取好友用户信息
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	mounted() {
		this.loadPendingRequests();
		this.openAddFriendFromRoute();
		
		// 监听好友申请数量更新事件
		this.$eventBus.$on('updateFriendRequestCount', (count) => {
			this.pendingRequests = Array(count).fill({}); // 临时填充，实际应该重新加载
			this.loadPendingRequests(); // 重新加载真实数据
		});
	},
	
	beforeDestroy() {
		// 移除事件监听
		this.$eventBus.$off('updateFriendRequestCount');
	},
	watch: {
		'$route.query.addFriend'() {
			this.openAddFriendFromRoute();
		}
	},
	computed: {
		hasPendingRequests() {
			return this.pendingRequests.length > 0;
		},
		pendingRequestCount() {
			return this.pendingRequests.length;
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friendMap() {
			// 按首字母分组
			let map = new Map();
			this.friendStore.friends.forEach((f) => {
				if (f.deleted) {
					return;
				}
				
				// 获取显示名称（备注或昵称）
				let displayName = f.nickName;
				try {
					const remarks = localStorage.getItem('friend_remarks');
					if (remarks) {
						const remarkMap = JSON.parse(remarks);
						if (remarkMap[f.id]) {
							displayName = remarkMap[f.id];
						}
					}
				} catch (error) {
					console.error('获取备注失败:', error);
				}
				
				// 搜索过滤
				if (this.searchText && !displayName.includes(this.searchText)) {
					return;
				}
				
				let letter = this.firstLetter(displayName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (f.online) {
					letter = '在线'
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			// 排序
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				// #组在最后面
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		friendKeys() {
			return Array.from(this.friendMap.keys());
		},
		friendValues() {
			return Array.from(this.friendMap.values());
		}
	}
}
</script>

<style lang="scss" scoped>
.friend-page {
	.aside {
		display: flex;
		flex-direction: column;
		background: var(--im-background);

		.header {
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0 8px;

			.add-btn {
				padding: 5px !important;
				margin: 5px;
				font-size: 16px;
				border-radius: 50%;
			}
			
			.request-btn {
				padding: 5px !important;
				margin: 5px;
				font-size: 16px;
				border-radius: 50%;
				position: relative;
				
				.request-count {
					position: absolute;
					top: -5px;
					right: -5px;
					background-color: #f56c6c;
					color: white;
					border-radius: 50%;
					width: 16px;
					height: 16px;
					font-size: 10px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}

		.friend-items {
			flex: 1;

			.letter {
				text-align: left;
				font-size: var(--im-larger-size-larger);
				padding: 5px 15px;
				color: var(--im-text-color-light);
			}
		}
	}

	.container {
		display: flex;
		flex-direction: column;

		.header {
			height: 50px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 12px;
			font-size: var(--im-font-size-larger);
			border-bottom: var(--im-border);
			box-sizing: border-box;
		}

		.friend-info {
			display: flex;
			padding: 50px 80px 20px 80px;
			text-align: center;

			.info-item {
				margin-left: 20px;
				background-color: #ffffff;
				border: 1px #ddd solid;
			}

			.description {
				padding: 20px 20px 0 20px;
			}
		}

		.btn-group {
			text-align: left !important;
			padding: 20px;
		}
	}
}
</style>
